import * as React from "react";
import {Component, ReactNode} from "react";
import {FormattedMessage} from 'react-intl';

export interface IExceptionFormatterProps {
    exception: Error | Error[] | string;
}

export default class ExceptionFormatter extends Component<IExceptionFormatterProps> {
    public render(): ReactNode {
        const { exception } = this.props;

        if(exception instanceof Error) {
            return <ExceptionFormatter exception={exception.message}/>;
        } else if(exception instanceof Array) {
            return (
                <span>
                    {exception.map((message, index) => {
                        return (
                            <span key={index}>{message}<br /></span>
                        );
                    })}
                </span>
            );
        } else if(exception) {
            return exception;
        } else {
            return <FormattedMessage id="ui.error" />;
        }
    }
}